var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$route.path.match('/login'))?_c('div',{attrs:{"id":"app"}},[_c('navigation-bar'),_vm._v(" "),_c('about-modal'),_vm._v(" "),_c('router-view')],1):_c('div',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-593d7529","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/App.vue
// module id = 182
// module chunks = 1